.fieldset {
  border: 0;
  display: flex;
  flex-direction: column;
  gap: 1rem;
  margin: 0;
  padding: 0;
}

.fieldset--inline {
  column-gap: 1.5rem;
  flex-direction: row;
}

.fieldset__legend {
  font-weight: var(--semibold);
  padding: 0;
}

.fieldset__description {
  margin: 0;
}
